import React, { useState, useEffect } from 'react';
import SmartTable from '../../../shared/components/SmartTable';
import LayoutWrapper from '../../../shared/components/LayoutWrapper';
import { useAuth } from '../../../shared/hooks/useAuth';
import api from '../../../shared/utils/api';

interface AppUser {
  [key: string]: any;
}

const AdminAppUserPage: React.FC = () => {
  const { userAuth } = useAuth();
  const [appUsers, setAppUsers] = useState<AppUser[]>([]);
  const [loading, setLoading] = useState(true);

  const defaultColumns = [
    { key: 'UserName', label: 'Нэвтрэх нэр', sortable: true },
    { key: 'FirstName', label: 'Нэр', sortable: true },
    { key: 'LastName', label: 'Овог', sortable: true },
    { key: 'RoleName', label: 'Эрх', sortable: true },
    { key: 'BankAccountnum', label: 'Банкны данс', sortable: true },
    { key: 'Employee', label: 'Ажилтан', sortable: true },
    { key: 'Customers', label: 'Захирал', sortable: true },
    { key: 'IsCitizen', label: 'Иргэн', sortable: true },
    { key: 'CreatedDate', label: 'Үүсгэсэн огноо', sortable: true }
  ];

  const transformAppUserData = (users: AppUser[]) => {
    return users.map(user => {
      const transformed: any = { ...user };
      
      // Handle GUID fields properly - they are uniqueidentifier, not boolean
      if (user.Accountant !== undefined && user.Accountant !== null) {
        transformed.Accountant = user.Accountant ? 'Тийм' : 'Үгүй';
      } else {
        transformed.Accountant = 'Үгүй'; // NULL values show as "Үгүй"
      }
      
      if (user.Customers !== undefined && user.Customers !== null) {
        transformed.Customers = user.Customers ? 'Тийм' : 'Үгүй';
      } else {
        transformed.Customers = 'Үгүй';
      }
      
      if (user.Employee !== undefined && user.Employee !== null) {
        transformed.Employee = user.Employee ? 'Тийм' : 'Үгүй';
      } else {
        transformed.Employee = 'Үгүй';
      }
      
      if (user.IsCitizen !== undefined && user.IsCitizen !== null) {
        transformed.IsCitizen = user.IsCitizen ? 'Тийм' : 'Үгүй';
      } else {
        transformed.IsCitizen = 'Үгүй';
      }

      // Handle BankAccountnum - show empty string instead of "Хоосон"
      if (user.BankAccountnum === null || user.BankAccountnum === undefined || user.BankAccountnum === '') {
        transformed.BankAccountnum = '';
      } else {
        transformed.BankAccountnum = user.BankAccountnum;
      }
      
      // Format CreatedDate
      if (user.CreatedDate) {
          const date = new Date(user.CreatedDate);
        transformed.CreatedDate = date.toLocaleDateString('mn-MN');
      }
      
      return transformed;
    });
  };

  const fetchAppUsers = async () => {
    try {
      setLoading(true);
      const result = await api.get('/admin/users');
      
      if (result.success) {
        setAppUsers(result.data);
      } else {
        console.error('Failed to fetch app users:', result.message);
      }
    } catch (error) {
      console.error('Error fetching app users:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAppUsers();
  }, []);

  if (loading) {
    return (
      <LayoutWrapper userAuth={userAuth}>
        <div className="p-6">
        <div className="flex justify-center items-center h-64">
          <div className="text-lg">Уншиж байна...</div>
          </div>
        </div>
      </LayoutWrapper>
    );
  }

  return (
    <LayoutWrapper userAuth={userAuth}>
      <div className="p-6">
                       <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800">Хэрэглэгчдийн жагсаалт</h1>
               </div>

        <SmartTable
          data={transformAppUserData(appUsers)}
          columns={defaultColumns}
          fetchData={fetchAppUsers}
          editable={false}
          addable={false}
          settingsKey="admin-app-users-table-view-only"
        />
      </div>
    </LayoutWrapper>
  );
};

export default AdminAppUserPage; 